import { Link } from 'react-router'
import logoRgb from '@/assets/brand/Logo_RGB.png'
import { Button } from '@/components/ui/button'
import { useDocumentTitle } from '@/lib/useDocumentTitle'

/**
 * Shown for any path no route matches. Inside a module shell it is a card in the
 * content area; `standalone` (no shell around it) centres it on the page with the logo.
 */
export function NotFoundPage({ standalone = false }: { standalone?: boolean }) {
  useDocumentTitle(['Niet gevonden'])
  const card = (
    <div
      className={
        standalone
          ? 'vonk-card flex w-full max-w-md flex-col items-center gap-3 p-6 text-center'
          : 'vonk-card my-10 flex max-w-md flex-col items-start gap-3 p-6'
      }
    >
      {standalone && <img src={logoRgb} alt="VONK Ventures" className="mb-2 w-40" />}
      <h1 className="text-xl font-semibold">Deze pagina bestaat niet of is verplaatst.</h1>
      <p className="text-sm text-muted-foreground">Controleer het adres of ga terug naar de startpagina.</p>
      <Button asChild>
        <Link to="/">Naar de startpagina</Link>
      </Button>
    </div>
  )
  if (!standalone) return card
  return <main className="flex min-h-svh items-center justify-center p-6">{card}</main>
}
